export const getCookieByName = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            var a = atob(c.substring(name.length, c.length));
            if (a !== "undefined") {
                return JSON.parse(a);
            } else return false;
        }
    }
    return false;
};

export const setCookieByName = (state, cname) => {
    var date = new Date();
    if (cname === "b__ck") {
        date.setTime(date.getTime() + (3600 * 1000 * 24 * 30));
    }
    if (cname === "b__lg" || cname === "b__di") {
        date.setTime(date.getTime() + (3600 * 1000 * 24 * 365));
    } else {
        date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    }
    var expires = "; path=/; expires=" + date.toGMTString();
    var cookie = `${cname}=${btoa(JSON.stringify(state))}${expires}`;
    document.cookie = cookie;
};

export const deleteAllCookies = () => {
    const cookies = ["b__ac", "b__ap", "b__ly"];
    for (var cookie of cookies) {
        document.cookie = [`${cookie}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/;`].join("");
    }
};

export const idExist = (id, array, iteration) => {
    for (var x = 0; x < array.length; x++) {
        if (array[x].id === id) {
            return (iteration) ? x : true;
        }
    }
    return false;
};

export const isPromotion = () => {
    var today = new Date();
    var promotion = new Date("January 31, 2022 23:59:59");

    if (today.getTime() < promotion.getTime()) {
        return true;
    } else {
        return false;
    }
};

export const sortBy = (array, type) => {
    array.sort(function (a, b) {
        if (a[type] < b[type]) {
            return -1;
        }
        if (a[type] > b[type]) {
            return 1;
        }
        return 0;
    });

    return array;
};

export const notifyBody = () => {
    return [1, 2, 3, 4].reverse();
};

export const getRoleName = (id) => {
    var roles = getRolesTypes();
    var element = returnElementFromArray(id, roles, "id");
    if (element) {
        return element.name;
    } else return "";
};

export const getUserBody = (lang) => {
    return {
        "password": "",
        "email": "",
        "first_name": "",
        "last_name": "",
        "lang": lang ? lang : "es",
        "timezone": "",
        "projects": [],
        "roles": [],
        "desk": {
            "access": {
                "only_assignee_tickets": false
            },
            "permissions": {
                "customers": {
                    "create": false,
                    "edit": false,
                    "read": true,
                    "delete": false
                }
            }
        },
        "campaigns": {
            "access": {
                "templates": false,
                "groups": false,
                "individual": false
            }
        }
    };
};

export const getRolesTypes = () => {
    return [
        {id: "29827f3b28404490afb0c77766a3279a", name: "Trainer"},
        {id: "dfa856ce88104968a7010b9a5e31fb58", name: "Administrator"},
        {id: "c35851102cab49ff9d31e71c4a82b4e1", name: "SuperAdministrator"},
        {id: "55f20c232859401da884b95bbd6535a4", name: "Agent"},
        {id: "115f18b805a14946824cb1fcfcf2e72d", name: "Supervisor"}
    ];
};

export const translate = (str, t) => {
    var s = t(str);
    if (s === str) {
        return t("backend_errors.internal_server");
    }
    return s;
};

export const convertException = (exc) => {
    var res;
    if (typeof (exc) === "object") {
        res = "internal_server_error";
    } else {
        res = exc.toLowerCase().replaceAll(".", "").replaceAll("/", "").replaceAll("'", "").replaceAll('"', "").replaceAll(",", "").replaceAll(":", "").replaceAll("-", "").replaceAll(" ", "_").replaceAll("(", "").replaceAll(")", "");
    }
    return res;
};

export const userLangObject = () => {
    return [
        {value: "en"},
        {value: "es"},
        {value: "pt"}
    ];
};

export const isValidEmail = (email) => {
    var regExp = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

    var r = regExp.test(email);
    return r;
};

export const returnElementFromArray = (el, array, type) => {
    for (var x = 0; x < array.length; x++) {
        if (array[x][type] === el) {
            return array[x];
        }
    }
    return false;
};

export const infoPlans = (plan) => {
    switch (plan) {
        case "free_trial":
            return [1, 2, 3];
        case "plan_m":
            return [1, 2, 3, 4, 5, 6, 7, 8];
        case "professional":
            return [1, 2, 3, 4, 5, 6, 7, 8, 9];
    }
};

export const addParamsProjectValue = (array) => {
    for (var x = 0; x < array.length; x++) {
        var str = array[x].name.replace(" ", "-");
        array[x].text = str.toLowerCase();
    }
    return array;
};

export const getServicesData = () => {

    return [
        {name: "setup_basic", svgType: "cog", plan_type: "all"},
        {name: "setup_premium", svgType: "cog", plan_type: "all"},
        {name: "botmaster", svgType: "cog", plan_type: "all"}
    ];

};

export const isValidPassword = (password) => {
    if (password?.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.,!?+\-*])(?=.{8,})/)) {
        return true;
    }
    return false;
};

export const getOrderBody = () => {
    return {
        "firstname": "",
        "lastname": "",
        "country": "",
        "timezone": "",
        "email": "",
        "phone": "",
        "interactions": "",
        "plan": ""
    };
};

export const getBillingBody = () => {
    return {
        "name": "",
        "lastname": "",
        "email": "",
        "phone": "",
        "company": "",
        "cif_nif": "",
        "address": "",
        "floor": "",
        "door": "",
        "postal_code": "",
        "country": "",
        "city": "",
        "dni": "",
        "province": ""
    };
};

export const getIncidencesDate = () => {
    return [
        {name: "less"},
        {name: "more"}
    ];
};

export const getIntegrationsData = () => {

    return [
        {name: "zendesk_full", plan_type: "all"},
        {name: "whatsapp", plan_type: "all"},
        {name: "centridesk", plan_type: "all"},
        {name: "zendesk_chat", plan_type: "all"},
        {name: "facebook_messenger", plan_type: "all"},
        {name: "instagram", plan_type: "all"},
        {name: "telegram", plan_type: "all"},
        {name: "wordpress", plan_type: "all"},
        {name: "sms", plan_type: "all"},
        {name: "zoho", plan_type: "all"},
        {name: "hubspot", plan_type: "all"},
        {name: "salesforce", plan_type: "all"},
        {name: "videortc", plan_type: "all"},
        {name: "live_chat", plan_type: "all"},
        {name: "playvox", plan_type: "all"}
    ];
};

export const getComparePlansData = () => {
    return [
        {
            title: "channels",
            channels: [
                {name: "whatsapp"},
                {name: "telegram"},
                {name: "instagram"},
                {name: "facebook_messenger"},
                {name: "whatsapp"}

            ],
            items: [
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {type: "string", plan: "consulting_enterprise"}],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {type: "string", plan: "consulting_enterprise"}],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {type: "string", plan: "consulting_enterprise"}],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }]]
        },
        {
            title: "management",
            items: [
                [{type: "string", plan: "free_trial",}, {type: "string", plan: "professional"}, {
                    type: "string",
                    plan: "consulting_professional"
                }, {type: "string", plan: "consulting_enterprise", infinity: true}],
                [{type: "string", plan: "free_trial"}, {type: "string", plan: "professional"}, {
                    type: "string",
                    plan: "consulting_professional"
                }, {type: "string", plan: "consulting_enterprise", infinity: true}],
                [{type: "string", plan: "free_trial"}, {type: "string", plan: "professional"}, {
                    type: "string",
                    plan: "consulting_professional"
                }, {type: "string", plan: "consulting_enterprise"}],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {type: "string", plan: "consulting_enterprise"}],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }]
            ]
        },
        {
            title: "utilities",
            items: [
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }]
            ]
        },
        {
            title: "integrations",
            items: [
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }]
            ]
        },
        {
            title: "centridesk",
            items: [
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {
                    type: "string",
                    plan: "consulting_enterprise",
                    infinity: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional",
                    string: "500mb"
                }, {type: "string", plan: "consulting_professional", string: "500mb"}, {
                    type: "string",
                    plan: "consulting_enterprise",
                    string: "1gb"
                }]
            ]
        },
        {
            title: "support",
            items: [
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: true}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {type: "string", plan: "consulting_enterprise"}],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: true
                }, {type: "bool", plan: "consulting_professional", value: true}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "string",
                    plan: "professional"
                }, {type: "string", plan: "consulting_professional"}, {type: "string", plan: "consulting_enterprise"}]
            ]
        },
        {
            title: "consulting_enterprise_nlp",
            items: [
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }],
                [{type: "bool", plan: "free_trial", value: false}, {
                    type: "bool",
                    plan: "professional",
                    value: false
                }, {type: "bool", plan: "consulting_professional", value: false}, {
                    type: "bool",
                    plan: "consulting_enterprise",
                    value: true
                }]
            ]
        }

    ];
};

export const getChannels = () => {
    return [
        {
            name: "Sunco",
            channel: "sunco",
            active: true
        },
        {
            name: "Sunco Campaigns",
            channel: "sunco_campaigns",
            active: true
        }
    ];
};

export const getSuncoConfig = (project_id) => {
    return {
        "project_id": project_id,
        "zendesk": {
            "tags": [],
            "historical_messages_number": 10,
            "return_to_bot_message": "Conversation closed by agent.",
            "ticket_field_conversation_id": ""
        },
        "bot": {
            "display_name": "Centribal Platform",
            "avatar_url": "https://chatadmintool-test-credentials.s3.eu-central-1.amazonaws.com/chats/default/img/00d7e48accea4e35be5c7ac40930b279.png"
        }
    };
};

export const isSuncoAccesible = (plan, user) => {
    const accountsList = ["4a8b56cb941248eebc3b19d2b71c70ab", "1f842ec122f94055afef189d8699be95", "eda8c8a6ea1342e3a03539bc3131b861", "d1a7a881424140908a8ce748a899af50", "77dc0ace8a38453ca477eb1efe1a246a", "d7ad104be2ad4361987a47fc521a1268", "9201694efd4c4abfa2dcfb8e2279be5f", "50c310d0f0544acaaa99a84c7365ddfb"];
    return plan.plan.name === "consulting_sunco" || accountsList.includes(user.account_id);
};